import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// ✅ Import legacy scripts AFTER globals are set
import reportWebVitals from './reportWebVitals';
import $ from "jquery";
window.$ = window.jQuery = $; // make globally available

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
